<template>
  <div id="app">
    <transition name="fade">
      <Loading
        class="loading_in"
        v-if="showLoading_ && ( $route.path == '/' || $route.path == '/sdgsindicators')"
      ></Loading>
    </transition>
    <!--  -->
    <Nav v-if="terminal == 'pc'"></Nav>
    <MobileNav v-else></MobileNav>
    <Cookies></Cookies>
    <!-- -->
    <div class="minHeight">
      <keep-alive
        exclude="DataServer,DataList,DataDetails,DataSearch,Articles,newslist,DataInfo,sdgsindicators,DataSearch"
      >
        <router-view></router-view>
      </keep-alive>
    </div>
    <Footer v-if="terminal == 'pc'"></Footer>
    <MobileFooter v-else></MobileFooter>
    <ToTop v-log="{params:{a:'totop',b:2}}"></ToTop>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  name: "app",
  data() {
    return {
      ifIndexPage: null,
      showLoading_: false,
      screenWidth: document.body.clientWidth
    };
  },
  computed: {},
  components: {
    Cookies: () => import("@/components/PublicComponents/Cookies/Cookies.vue"),
    Loading: () => import("@/components/PublicComponents/Loading/Loading.vue"),
    Nav: () => import("@/components/PublicComponents/Nav/Nav.vue"),
    MobileNav: () => import("@/components/PublicComponents/Mobile/Nav/Nav.vue"),
    Footer: () => import("@/components/PublicComponents/Footer/Footer.vue"),
    MobileFooter: () =>
      import("@/components/PublicComponents/Mobile/Footer/Footer.vue"),
    ToTop: () => import("@/components/PublicComponents/ToTop/ToTop.vue")
  },
  mounted() {
    // document.body.style.zoom = 1 / window.devicePixelRatio;
   
    if (localStorage.getItem("locale")) {
      if (
        localStorage.getItem("locale") == "zh" ||
        localStorage.getItem("locale") == "en" ||
        localStorage.getItem("locale") == "fran"
      ) {
        this.setLanguage(localStorage.getItem("locale"));
      } else {
        this.setLanguage("zh");
        localStorage.setItem("locale",'zh');
      }
    } else {
      this.setLanguage("zh");
      localStorage.setItem("locale",'zh');
    }

    this.setLoginName(
      localStorage.getItem("loginName") ? localStorage.getItem("loginName") : ""
    );
    // 判断当前的浏览器终端
    if (this.screenWidth <= 768) {
      this.setTerminal("phone");
    } else {
      this.setTerminal("pc");
    }
    // 监听浏览器的改变
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
      if (this.screenWidth <= 768) {
        this.setTerminal("phone");
      } else {
        this.setTerminal("pc");
      }
    };
    if (this.$route.path == "/") {
      this.showLoading_ = true;
      this.ifIndexPage = true;
    } else {
      this.ifIndexPage = false;
    }
    setTimeout(() => {
      this.showLoading_ = false;
    }, 3000);
    bus.$on("showLoadingFun", val => {
      this.showLoading_ = val;
    });
  },
  methods: {
    //获取屏幕缩放比例
     getRatio() {
      var ratio = 0;
      var screen = window.screen;
      var ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }

      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
  }
};
</script>


<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
  position: absolute;
}

.minHeight {
  // min-height: 100vh;
  // background: #fff;
}
.loading_in {
  position: fixed;
  background: #fff;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
}
.fade-enter-active,
.fade-leave-active {
  transition: 0.3s;
}
.fade-enter {
  opacity: 1;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
